const focusFirstInteractive = (container) => {
    const element = container?.jquery ? container[0] : container;
    if (!element) {
        return;
    }
    const focusableSelector = [
        "a[href]",
        "area[href]",
        "input:not([disabled]):not([type='hidden'])",
        "select:not([disabled])",
        "textarea:not([disabled])",
        "button:not([disabled])",
        "iframe",
        "object",
        "embed",
        "[contenteditable]",
        "[tabindex]"
    ].join(", ");
    const focusableElements = Array.from(element.querySelectorAll(focusableSelector)).filter((el) => {
        return !el.hasAttribute("disabled") && (el.offsetParent !== null || el.getClientRects().length > 0);
    });
    if (focusableElements.length > 0) {
        focusableElements[0].focus();
        return;
    }
    if (!element.hasAttribute("tabindex")) {
        element.setAttribute("tabindex", "-1");
    }
    element.focus();
};

export { focusFirstInteractive };
